import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "radiologyReportPersistedState", // storage key
  storage: localStorage, // or sessionStorage
});
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const radiologyReportsLoadedState = atom({
  key: "radiologyReportsLoadedState",
  default: false,
});

export const radiologyReportState = atom({
  key: "radiologyReportState",
  default: [],
});

export const rowLoadingState = atom({
  key: "radiologyRowLoadingState",
  default: false,
});

export const formattedFromDateState = atom({
  key: "radiologyFormattedFromDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const formattedToDateState = atom({
  key: "radiologyFormattedToDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const fromDateState = atom({
  key: "radiologyFromDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});

export const toDateState = atom({
  key: "radiologyToDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});
